export default __webpack_public_path__ + "static/media/recenter_icon_bold.8c684cbf.svg";